/**
 * Evolution Wheels — Configuratore Cerchi & Coprimozzo
 * v4.1 — assets/ew-cfg-v4.js
 * Novità v4.1: dropdown custom con label + spunta verde, tab dentro il box
 */

(function () {
  'use strict';

  const cfg = window.ewConfig || {};
  const CDN = cfg.cdn || '';

  let indexData   = null;
  let brandData   = null;
  let loadedBrand = null;
  let hubcapData  = null;

  const $ = (id) => document.getElementById(id);

  // ── DROPDOWN CUSTOM HELPERS ────────────────────────────
  function ddSetOptions(wrapId, options) {
    const wrap = $(wrapId);
    if (!wrap) return;
    const list = wrap.querySelector('.ew-dd-list');
    list.innerHTML = '';
    options.forEach(({ value, label }) => {
      const opt = document.createElement('div');
      opt.className = 'ew-dd-option';
      opt.dataset.value = value;
      opt.textContent = label;
      opt.addEventListener('click', () => ddSelect(wrapId, value, label));
      list.appendChild(opt);
    });
  }

  function ddSelect(wrapId, value, label) {
    const wrap = $(wrapId);
    if (!wrap) return;
    const trigger = wrap.querySelector('.ew-dd-trigger');
    const left    = trigger.querySelector('.ew-dd-left');
    left.innerHTML = `<span class="ew-dd-label">${trigger.querySelector('.ew-dd-label')?.textContent || ''}</span><span class="ew-dd-value">${label}</span>`;
    // Recupera la label originale dal placeholder se non c'è ancora una label
    const placeholder = trigger.dataset.placeholder || '';
    left.innerHTML = `<span class="ew-dd-label">${placeholder}</span><span class="ew-dd-value">${label}</span>`;
    trigger.classList.add('ew-dd--selected');
    trigger.dataset.value = value;
    ddClose(wrapId);
    // Evidenzia opzione attiva
    wrap.querySelectorAll('.ew-dd-option').forEach(o => {
      o.classList.toggle('ew-dd--active', o.dataset.value === value);
    });
    // Dispatch evento custom per il resto della logica
    wrap.dispatchEvent(new CustomEvent('ew:select', { detail: { value }, bubbles: true }));
  }

  function ddReset(wrapId, placeholder) {
    const wrap = $(wrapId);
    if (!wrap) return;
    const trigger = wrap.querySelector('.ew-dd-trigger');
    const left    = trigger.querySelector('.ew-dd-left');
    left.innerHTML = `<span class="ew-dd-placeholder">${placeholder}</span>`;
    trigger.classList.remove('ew-dd--selected');
    trigger.dataset.value = '';
    trigger.dataset.placeholder = placeholder;
    const list = wrap.querySelector('.ew-dd-list');
    list.innerHTML = '';
    ddClose(wrapId);
  }

  function ddEnable(wrapId, placeholder) {
    const wrap = $(wrapId);
    if (!wrap) return;
    const trigger = wrap.querySelector('.ew-dd-trigger');
    trigger.classList.remove('ew-dd--disabled');
    trigger.dataset.placeholder = placeholder || trigger.dataset.placeholder || '';
  }

  function ddDisable(wrapId) {
    const wrap = $(wrapId);
    if (!wrap) return;
    wrap.querySelector('.ew-dd-trigger').classList.add('ew-dd--disabled');
    ddClose(wrapId);
  }

  function ddOpen(wrapId) {
    const wrap = $(wrapId);
    if (!wrap) return;
    // Chiudi tutti gli altri
    document.querySelectorAll('.ew-dd-wrap.ew-dd--open').forEach(w => {
      if (w !== wrap) w.classList.remove('ew-dd--open');
    });
    wrap.classList.toggle('ew-dd--open');
    const trigger = wrap.querySelector('.ew-dd-trigger');
    trigger.setAttribute('aria-expanded', wrap.classList.contains('ew-dd--open'));
  }

  function ddClose(wrapId) {
    const wrap = $(wrapId);
    if (!wrap) return;
    wrap.classList.remove('ew-dd--open');
    const trigger = wrap.querySelector('.ew-dd-trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function ddGetValue(wrapId) {
    const wrap = $(wrapId);
    if (!wrap) return '';
    return wrap.querySelector('.ew-dd-trigger')?.dataset.value || '';
  }

  function ddBindTrigger(wrapId) {
    const wrap = $(wrapId);
    if (!wrap) return;
    wrap.querySelector('.ew-dd-trigger').addEventListener('click', () => {
      if (!wrap.querySelector('.ew-dd-trigger').classList.contains('ew-dd--disabled')) {
        ddOpen(wrapId);
      }
    });
  }

  // Chiudi dropdown cliccando fuori
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.ew-dd-wrap')) {
      document.querySelectorAll('.ew-dd-wrap.ew-dd--open').forEach(w => w.classList.remove('ew-dd--open'));
    }
  });

  // ── INIT ───────────────────────────────────────────────
  async function init() {
    try {
      const [idx, hub] = await Promise.all([
        fetch(CDN + 'index_v4.json').then(r => r.json()),
        fetch(CDN + 'hubcap.json').then(r => r.json())
      ]);
      if (idx) {
        indexData = idx;
        const placeholder = cfg.label_brand || 'Marca';
        ddEnable('ew-w-brand-wrap', placeholder);
        ddSetOptions('ew-w-brand-wrap', idx.brands.map(b => ({ value: b, label: titleCase(b) })));
      }
      if (hub) {
        hubcapData = hub;
        const placeholder = cfg.label_hub_brand || 'Marca';
        ddEnable('ew-h-brand-wrap', placeholder);
        ddSetOptions('ew-h-brand-wrap', Object.keys(hub).sort().map(b => ({ value: b, label: b })));
      }
    } catch (e) {
      console.warn('[EW] Errore caricamento dati:', e);
    }
  }

  // ── TABS ───────────────────────────────────────────────
  function initTabs() {
    document.querySelectorAll('.ew-tab').forEach(tab => {
      tab.addEventListener('click', () => {
        document.querySelectorAll('.ew-tab').forEach(t => t.classList.toggle('ew-tab--active', t === tab));
        document.querySelectorAll('.ew-mode').forEach(m => {
          m.style.display = m.id === 'ew-mode-' + tab.dataset.mode ? 'flex' : 'none';
        });
      });
    });
  }

  // ── WHEELS: MARCA ──────────────────────────────────────
  async function onWheelsBrand(brand) {
    ddReset('ew-w-model-wrap', cfg.label_model || 'Modello');
    ddReset('ew-w-body-wrap',  cfg.label_body  || 'Carrozzeria');
    ddReset('ew-w-power-wrap', cfg.label_power || 'Potenza (kW)');
    ddDisable('ew-w-model-wrap');
    ddDisable('ew-w-body-wrap');
    ddDisable('ew-w-power-wrap');
    $('ew-w-btn').disabled = true;
    if (!brand) return;
    if (loadedBrand !== brand) {
      try {
        const slug = brand.replace(/\s+/g,'_').replace(/\//g,'_').toLowerCase();
        brandData   = await fetch(CDN + slug + '_v4.json').then(r => r.json());
        loadedBrand = brand;
      } catch(e) { console.warn('[EW] Errore brand:', brand, e); return; }
    }
    const models = indexData?.models[brand] || [];
    ddSetOptions('ew-w-model-wrap', models.map(m => ({ value: m, label: titleCase(m) })));
    ddEnable('ew-w-model-wrap', cfg.label_model || 'Modello');
  }

  // ── WHEELS: MODELLO ────────────────────────────────────
  function onWheelsModel(model) {
    ddReset('ew-w-body-wrap',  cfg.label_body  || 'Carrozzeria');
    ddReset('ew-w-power-wrap', cfg.label_power || 'Potenza (kW)');
    ddDisable('ew-w-body-wrap');
    ddDisable('ew-w-power-wrap');
    $('ew-w-btn').disabled = true;
    if (!model || !brandData) return;
    const bodies = brandData.bodies?.[model] || [];
    ddSetOptions('ew-w-body-wrap', bodies.map(b => ({ value: b, label: b })));
    ddEnable('ew-w-body-wrap', cfg.label_body || 'Carrozzeria');
  }

  // ── WHEELS: CARROZZERIA ────────────────────────────────
  function onWheelsBody(body) {
    ddReset('ew-w-power-wrap', cfg.label_power || 'Potenza (kW)');
    ddDisable('ew-w-power-wrap');
    $('ew-w-btn').disabled = true;
    if (!body) return;
    const model  = ddGetValue('ew-w-model-wrap');
    const pkey   = model + '|||' + body;
    const powers = brandData?.powers?.[pkey] || [];
    if (powers.length <= 1) {
      const p = powers[0] || 'all';
      const label = p === 'all' ? 'Tutte' : p + ' kW';
      ddSetOptions('ew-w-power-wrap', [{ value: p, label }]);
      // Auto-seleziona
      const wrap = $('ew-w-power-wrap');
      const trigger = wrap.querySelector('.ew-dd-trigger');
      trigger.dataset.placeholder = cfg.label_power || 'Potenza (kW)';
      trigger.dataset.value = p;
      trigger.classList.add('ew-dd--selected');
      const left = trigger.querySelector('.ew-dd-left');
      left.innerHTML = `<span class="ew-dd-label">${cfg.label_power || 'Potenza (kW)'}</span><span class="ew-dd-value">${label}</span>`;
      ddDisable('ew-w-power-wrap');
      $('ew-w-btn').disabled = false;
      return;
    }
    ddSetOptions('ew-w-power-wrap', powers.map(p => ({ value: p, label: p + ' kW' })));
    ddEnable('ew-w-power-wrap', cfg.label_power || 'Potenza (kW)');
  }

  // ── WHEELS: CERCA ──────────────────────────────────────
  function onWheelsSearch() {
    const model = ddGetValue('ew-w-model-wrap');
    const body  = ddGetValue('ew-w-body-wrap');
    const power = ddGetValue('ew-w-power-wrap');
    if (!model || !body) return;
    let skus = [];
    if (power && power !== 'all') {
      const fkey    = model + '|||' + body + '|||' + power;
      const indices = brandData?.fitment?.[fkey] || [];
      skus = indices.map(i => brandData.eans[i]);
    } else {
      const pkey   = model + '|||' + body;
      const powers = brandData?.powers?.[pkey] || [];
      const skuSet = new Set();
      powers.forEach(p => {
        (brandData?.fitment?.[model + '|||' + body + '|||' + p] || [])
          .forEach(i => skuSet.add(brandData.eans[i]));
      });
      skus = [...skuSet];
    }
    redirectSearch(skus, 'wheels', {
      make:      ddGetValue('ew-w-brand-wrap'),
      model,
      sub_model: body,
      engine:    power || 'all'
    });
  }

  // ── HUBCAP ─────────────────────────────────────────────
  function onHubBrand(brand) {
    ddReset('ew-h-model-wrap', cfg.label_hubcap || 'Coprimozzo');
    ddReset('ew-h-diam-wrap',  cfg.label_diam   || 'Diametro');
    ddReset('ew-h-pcd-wrap',   cfg.label_pcd    || 'PCD');
    ddDisable('ew-h-model-wrap');
    ddDisable('ew-h-diam-wrap');
    ddDisable('ew-h-pcd-wrap');
    $('ew-h-btn').disabled = true;
    if (!brand || !hubcapData?.[brand]) return;
    ddSetOptions('ew-h-model-wrap', Object.keys(hubcapData[brand]).sort().map(m => ({ value: m, label: m })));
    ddEnable('ew-h-model-wrap', cfg.label_hubcap || 'Coprimozzo');
  }

  function onHubModel(model) {
    const brand = ddGetValue('ew-h-brand-wrap');
    ddReset('ew-h-diam-wrap', cfg.label_diam || 'Diametro');
    ddReset('ew-h-pcd-wrap',  cfg.label_pcd || 'PCD');
    ddDisable('ew-h-diam-wrap');
    ddDisable('ew-h-pcd-wrap');
    $('ew-h-btn').disabled = true;
    if (!model || !hubcapData?.[brand]?.[model]) return;
    const diams = Object.keys(hubcapData[brand][model]).sort((a,b) => parseFloat(a) - parseFloat(b));
    ddSetOptions('ew-h-diam-wrap', diams.map(d => ({ value: d, label: d + '"' })));
    ddEnable('ew-h-diam-wrap', cfg.label_diam || 'Diametro');
    // Bottone abilitato già dopo il modello
    $('ew-h-btn').disabled = false;
  }

  function onHubDiam(diam) {
    const brand = ddGetValue('ew-h-brand-wrap');
    const model = ddGetValue('ew-h-model-wrap');
    ddReset('ew-h-pcd-wrap', cfg.label_pcd || 'PCD');
    ddDisable('ew-h-pcd-wrap');
    // Bottone rimane abilitato anche senza PCD
    if (!diam || !hubcapData?.[brand]?.[model]?.[diam]) return;
    const pcds = Object.keys(hubcapData[brand][model][diam]).sort();
    ddSetOptions('ew-h-pcd-wrap', pcds.map(p => ({ value: p, label: p })));
    ddEnable('ew-h-pcd-wrap', cfg.label_pcd || 'PCD');
  }

  function onHubSearch() {
    const brand = ddGetValue('ew-h-brand-wrap');
    const model = ddGetValue('ew-h-model-wrap');
    const diam  = ddGetValue('ew-h-diam-wrap');
    const pcd   = ddGetValue('ew-h-pcd-wrap');
    if (!brand || !model) return;

    const skuSet = new Set();

    if (diam && pcd) {
      // Tutti e 4 i campi — ricerca precisa
      (hubcapData?.[brand]?.[model]?.[diam]?.[pcd] || []).forEach(s => skuSet.add(s));
    } else if (diam) {
      // Senza PCD — tutti i PCD per quel diametro
      const pcds = Object.keys(hubcapData?.[brand]?.[model]?.[diam] || {});
      pcds.forEach(p => (hubcapData[brand][model][diam][p] || []).forEach(s => skuSet.add(s)));
    } else {
      // Solo marca + modello — tutti i diametri e PCD
      const diams = Object.keys(hubcapData?.[brand]?.[model] || {});
      diams.forEach(d => {
        Object.keys(hubcapData[brand][model][d] || {}).forEach(p => {
          (hubcapData[brand][model][d][p] || []).forEach(s => skuSet.add(s));
        });
      });
    }

    const state = { mode: 'hubcap', make: brand, model, sub_model: diam || '', engine: pcd || '' };
    redirectSearch([...skuSet], 'hubcap', state);
  }

  // ── REDIRECT ───────────────────────────────────────────
  function redirectSearch(skus, mode, state) {
    if (!skus.length) { alert('Nessun prodotto trovato'); return; }
    // Salva in sessionStorage per il carrello
    try { sessionStorage.setItem('ew_vehicle', JSON.stringify({ mode, ...state })); } catch(e) {}
    const query = skus.slice(0, 20).map(s => `variants.sku:"${s}"`).join(' OR ');
    const m = encodeURIComponent(JSON.stringify({ mode, ...state, path: '/', domain: window.location.hostname }));
    window.location.href = '/search?type=product&options[unavailable_products]=last&q=(' + encodeURIComponent(query) + ')&m=' + m;
  }

  // ── UTILS ──────────────────────────────────────────────
  function titleCase(str) {
    if (!str) return '';
    return str.split(/(\s+|-)/).map(w => {
      if (/^\s+$/.test(w) || w === '-') return w;
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join('');
  }

  // ── BIND EVENTI ────────────────────────────────────────
  function bindEvents() {
    // Wheels
    ddBindTrigger('ew-w-brand-wrap');
    ddBindTrigger('ew-w-model-wrap');
    ddBindTrigger('ew-w-body-wrap');
    ddBindTrigger('ew-w-power-wrap');

    $('ew-w-brand-wrap')?.addEventListener('ew:select', e => onWheelsBrand(e.detail.value));
    $('ew-w-model-wrap')?.addEventListener('ew:select', e => onWheelsModel(e.detail.value));
    $('ew-w-body-wrap')?.addEventListener('ew:select',  e => onWheelsBody(e.detail.value));
    $('ew-w-power-wrap')?.addEventListener('ew:select', () => { $('ew-w-btn').disabled = !ddGetValue('ew-w-power-wrap'); });
    $('ew-w-btn')?.addEventListener('click', onWheelsSearch);

    // Hubcap
    ddBindTrigger('ew-h-brand-wrap');
    ddBindTrigger('ew-h-model-wrap');
    ddBindTrigger('ew-h-diam-wrap');
    ddBindTrigger('ew-h-pcd-wrap');

    $('ew-h-brand-wrap')?.addEventListener('ew:select', e => onHubBrand(e.detail.value));
    $('ew-h-model-wrap')?.addEventListener('ew:select', e => onHubModel(e.detail.value));
    $('ew-h-diam-wrap')?.addEventListener('ew:select',  e => onHubDiam(e.detail.value));
    $('ew-h-pcd-wrap')?.addEventListener('ew:select',  () => { $('ew-h-btn').disabled = !ddGetValue('ew-h-pcd-wrap'); });
    $('ew-h-btn')?.addEventListener('click', onHubSearch);
  }

  // ── INIT PLACEHOLDER DATA ──────────────────────────────
  function initPlaceholders() {
    [
      ['ew-w-brand-wrap', cfg.label_brand || 'Marca'],
      ['ew-w-model-wrap', cfg.label_model || 'Modello'],
      ['ew-w-body-wrap',  cfg.label_body  || 'Carrozzeria'],
      ['ew-w-power-wrap', cfg.label_power || 'Potenza (kW)'],
      ['ew-h-brand-wrap', cfg.label_hub_brand || 'Marca'],
      ['ew-h-model-wrap', cfg.label_hubcap    || 'Coprimozzo'],
      ['ew-h-diam-wrap',  cfg.label_diam      || 'Diametro'],
      ['ew-h-pcd-wrap',   cfg.label_pcd       || 'PCD'],
    ].forEach(([wrapId, ph]) => {
      const wrap = $(wrapId);
      if (!wrap) return;
      const trigger = wrap.querySelector('.ew-dd-trigger');
      if (trigger) trigger.dataset.placeholder = ph;
    });
    // Brand wheels è sempre abilitato (si abilita dopo il fetch)
    ddDisable('ew-w-model-wrap');
    ddDisable('ew-w-body-wrap');
    ddDisable('ew-w-power-wrap');
    ddDisable('ew-h-model-wrap');
    ddDisable('ew-h-diam-wrap');
    ddDisable('ew-h-pcd-wrap');
  }

  // ── MOVEINTOSLIDESHOW ──────────────────────────────────
  function moveIntoSlideshow() {
    var panel = document.querySelector('[class*="ew-panel"]');
    if (!panel) return;
    var section = panel.closest('[id^="shopify-section-"]');
    if (!section) return;
    var slideshow = document.getElementById('shopify-section-template--31484758950219__ss_slideshow_4_ggQTnL');
    if (!slideshow) return;
    var container = slideshow.querySelector('[class*="-settings"]');
    if (!container) container = slideshow;
    container.style.position = 'relative';
    section.style.position = 'absolute';
    section.style.zIndex = '9';
    section.style.background = 'transparent';
    container.appendChild(section);
    console.log('[EW] Spostato in:', container.className.slice(0,50));
  }

  // ── AVVIO ──────────────────────────────────────────────
  function start() {
    initTabs();
    initPlaceholders();
    bindEvents();
    init();
    moveIntoSlideshow();
  }

  if (document.readyState === 'complete') {
    start();
  } else {
    window.addEventListener('load', start);
  }

})();